webpackJsonp([133845105845689],{

/***/ 1534:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/en/assessment/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---en-assessment-dbf98546cd7ee67c65f4.js